import React, { Component } from 'react';
import SquareBorderButton from '@lyearn-team/frontend-components/dist/Button/SquareBorderButton';
import FloatingLabelInput from '@lyearn-team/frontend-components/dist/Input/FloatingLabelInput';
import Divider from '@lyearn-team/frontend-components/dist/Divider';
import Select from '@lyearn-team/frontend-components/dist/Select/Select';
import { showSnackbar } from '@lyearn-team/frontend-components/dist/showSnackbar/showSnackbar';
import { url } from '../../../helper/url';
import {
  CompanyPageWrapper,
  Heading,
  LabelText,
  FlexContainer,
  EmailContainer,
  SelectContainer,
  ButtonWrapper,
  InfoContainer,
  ContactEmail,
  SendEmailText,
  ErrorMessage
} from './styles';

const companySizeOptions = [
  {
    label: '1-15',
    value: '1-15'
  },
  {
    label: '16-50',
    value: '16-50'
  },
  {
    label: '50-100',
    value: '50-100'
  },
  {
    label: '101-500',
    value: '101-500'
  },
  {
    label: '500-1000',
    value: '500-1000'
  },
  {
    label: '1000+',
    value: '1000+'
  }
];
const toEmail = 'lyearndummy@gmail.com';

export default class RequestDemo extends Component {
  state = {
    email: '',
    emailError: '',
    companySize: '',
    companySizeError: '',
    message: '',
    messageError: '',
    icon: ''
  };

  onEmailChange = e => {
    const email = e.target.value;
    this.setState(() => ({
      email,
      emailError: '',
      icon: ''
    }));
  };

  onMessageChange = e => {
    const message = e.target.value;
    this.setState(() => ({
      message,
      messageError: '',
      icon: ''
    }));
  };

  onCompanySizeChange = size => {
    const companySize = size.value;
    this.setState(() => ({
      companySize,
      companySizeError: '',
      icon: ''
    }));
  };

  onButtonClick = () => {
    const { icon } = this.state;
    if (!icon) {
      const { email } = this.state;
      if (email) {
        if (this.validateEmail(email)) {
          const { companySize } = this.state;
          if (companySize) {
            const { message } = this.state;
            if (message) {
              // const formData = new FormData();
              const formData = new URLSearchParams();
              formData.append('from', email);
              formData.append('to', toEmail);
              formData.append('subject', `Demo request -- team size:${companySize}`);
              formData.append('emailBody', message);
              fetch(url + '/sendEmail', {
                method: 'POST',
                body: formData
              })
                .then(res => res.json())
                .then(response => {
                  if (response) {
                    this.setState(() => ({
                      icon: 'check'
                    }));
                    this.showStatus(
                      "Thank you for contacting us! We'll be in touch shortly..",
                      'success'
                    );
                    // return response;
                  }
                })
                .catch(() => {
                  this.showStatus(
                    "Oops, that didn't go through. Please check your internet connection.",
                    'error'
                  );
                });
            } else {
              this.setState(() => ({
                messageError: 'Message cannot be empty.'
              }));
            }
          } else {
            this.setState(() => ({
              companySizeError: 'Please Select your Company Size'
            }));
          }
        } else {
          this.setState(() => ({
            emailError: 'Email not valid.'
          }));
        }
      } else {
        this.setState(() => ({
          emailError: 'Email cannot be empty.'
        }));
      }
    }
  };

  validateEmail = email => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  showStatus(label, status) {
    showSnackbar({
      label,
      status
    });
  }

  render() {
    const {
      email,
      emailError,
      companySize,
      companySizeError,
      message,
      messageError,
      icon
    } = this.state;
    const selectLabel = companySize || 'Select';
    const headingText = "We can't wait to meet you!";
    return (
      <CompanyPageWrapper>
        <Heading>{headingText}</Heading>
        <React.Fragment>
          <FlexContainer>
            <EmailContainer>
              <LabelText>Work Email*</LabelText>
              <FloatingLabelInput
                value={email}
                error={emailError}
                onChange={this.onEmailChange}
                placeholder="someone@example.com"
              />
            </EmailContainer>
            <SelectContainer>
              <LabelText>Company Size*</LabelText>
              <Select
                options={companySizeOptions}
                label={selectLabel}
                onSelect={this.onCompanySizeChange}
              />
              {companySizeError && <ErrorMessage>{companySizeError}</ErrorMessage>}
            </SelectContainer>
          </FlexContainer>
        </React.Fragment>
        <LabelText>Message*</LabelText>
        <FloatingLabelInput
          value={message}
          onChange={this.onMessageChange}
          placeholder="Your Message"
          error={messageError}
          multiline={true}
          minRows={2}
        />
        <ButtonWrapper>
          <SquareBorderButton
            text={icon ? '' : 'CONTINUE'}
            type="filled"
            onClick={this.onButtonClick}
            icon={{ type: { icon }, style: { width: '18px', marginRight: '6px' } }}
            style={{ width: '212px', borderRadius: '100px', alignSelf: 'center' }}
          />
        </ButtonWrapper>
        <Divider />
        <InfoContainer>
          <SendEmailText>OR, SEND US AN EMAIL AT</SendEmailText>
          <ContactEmail href="mailto:contact@lyearn.com">contact@lyearn.com</ContactEmail>
        </InfoContainer>
      </CompanyPageWrapper>
    );
  }
}
